/* eslint-disable max-classes-per-file */
import APIClient from 'wootils/shared/apiClient';
import 'yetch/polyfill';

class AppAPIException extends Error {
  constructor(message, status, aborted) {
    super(message);
    this.name = this.constructor.name;
    this.status = status;
    this.aborted = aborted;
  }
}

class AppAPIBase extends APIClient {
  constructor(httpClient, appConfiguration) {
    'inject';

    const api = appConfiguration.get('api');
    super(
      api.url,
      api.endpoints,
      httpClient.fetch.bind(httpClient),
    );

    this._httpClient = httpClient;
    this._appConfiguration = appConfiguration;
  }
  fetch(options) {
    const abortController = new AbortController();
    const newOptions = Object.assign({}, options, {
      signal: abortController.signal,
    });

    const request = super.fetch(newOptions);

    const requestProto = Object.getPrototypeOf(request);
    Object.defineProperty(requestProto, 'abort', {
      value: abortController.abort.bind(abortController),
      writable: true,
    });

    return request
    .then((response) => response.data || response)
    .catch((error) => {
      let nextError;
      if (error.name === 'AbortError') {
        nextError = new AppAPIException('Request aborted', 0, true);
      } else {
        nextError = error;
      }

      return Promise.reject(nextError);
    });
  }
  error(response, status) {
    return new AppAPIException(
      this._getMessageFromResponse(response),
      status,
      false,
    );
  }
  _getMessageFromResponse(response) {
    let message;
    if (response.error) {
      message = response.error;
    } else if (response.data && response.data && response.data.message) {
      ({ message } = response.data);
    } else if (response.data && response.data && response.data.error) {
      message = response.data.error;
    } else {
      message = 'Unexpected error';
    }

    return message;
  }
}

export {
  AppAPIBase,
  AppAPIException,
};
